// This validator takes a control name and an array of excluded control names
// It will fail when the control has a value and any of the excluded controls have values

import { AbstractControl, ValidatorFn } from "@angular/forms"

export function ExclusiveValidator(controlName: string, excludedControlNames: string[], exceptionText: string): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    let control = group.get(controlName);

    let anyExcludedValue = false;
    for (let excludedControlName of excludedControlNames) {
      let excludedControl = group.get(excludedControlName);
      if (excludedControl && excludedControl.value && excludedControl.value != exceptionText) {
        anyExcludedValue = true;
        break;
      }
    }

    return (control && control.value && anyExcludedValue) ? { "exclusive": true } : null;
  }
}
